import { Action as ReduxAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { reducer } from './reducer'

export const CLEAR_PRIVATE_CONTENT = 'CLEAR_PRIVATE_CONTENT'
export const CLEAR_TRANSIENT_STATE = 'CLEAR_TRANSIENT_STATE'

export type RedDataState = ReturnType<typeof reducer>

export interface RedDataAction extends ReduxAction {
  type: string
  payload?: any
}

export class UserFacingError extends Error {
  constructor(
    public friendlyString: string,
    debugError?: string
  ) {
    super(`UserFacingError: ${debugError || 'no debug message'} (presented as "${friendlyString}")`)
  }
}

// eslint-disable-next-line sonarjs/redundant-type-aliases -- will come back to this
export type ContentfulRichText = any // Used for API documentation

export type DispatchFunction = ThunkDispatch<RedDataState, void, RedDataAction>
export type GetRedDataState = () => RedDataState

/* ********** Temporary home for categories & discovery types ********** */
export interface CategoriesResponse {
  categories?: RewardCategory[]
  categoryCostCounts?: {
    [key: string]: PointsRange
  }
}

export interface RewardCategory {
  categoryName: string
  categoryLogo: string
  descriptor: string
}

export interface PointsRange {
  [key: string]: number
}

export enum RewardsSort {
  CostAsc = 'cost',
  CostDesc = '-cost',
  TitleAsc = 'title',
  TitleDesc = '-title',
  CreatedDate = 'createdDate',
  Popular = 'popular',
  DateAsc = 'date',
  DateDesc = '-date',
}

export interface Filters {
  selectedCategories: string[]
  selectedCategoryCostCounts: string[]
}
